<template lang="html">
<svg xmlns="http://www.w3.org/2000/svg" width="11.36" height="11.36" viewBox="0 0 11.36 11.36">
  <g id="streamline-icon-notes-book_140x140" data-name="streamline-icon-notes-book@140x140" transform="translate(0.5 0.5)">
    <path id="Path_44731" data-name="Path 44731" class="cls-1" d="M4.375,26.25H5.756" transform="translate(-4.375 -24.523)"/>
    <path id="Path_44732" data-name="Path 44732" class="cls-1" d="M4.375,70H5.756" transform="translate(-4.375 -64.82)"/>
    <path id="Path_44733" data-name="Path 44733" class="cls-1" d="M4.375,105H5.756" transform="translate(-4.375 -97.057)"/>
    <path id="Path_44734" data-name="Path 44734" class="cls-1" d="M13.125,4.375h7.943v10.36H13.125Z" transform="translate(-12.434 -4.375)"/>
    <path id="Path_44735" data-name="Path 44735" class="cls-1" d="M43.756,30.625h3.8v2.417h-3.8Z" transform="translate(-40.647 -28.553)"/>
    <path id="Path_44736" data-name="Path 44736" class="cls-1" d="M113.75,13.125v6.216h1.036a.691.691,0,0,0,.691-.691V13.816a.691.691,0,0,0-.691-.691Z" transform="translate(-105.117 -12.434)"/>
    <path id="Path_44737" data-name="Path 44737" class="cls-1" d="M113.75,39.375h1.727" transform="translate(-105.117 -36.612)"/>
    <path id="Path_44738" data-name="Path 44738" class="cls-1" d="M113.75,65.625h1.727" transform="translate(-105.117 -60.79)"/>
  </g>
</svg>

</template>

<script>
export default {
  name: 'IconSalesGrammar',
};
</script>
<style lang="scss" scoped>
.cls-1 {
    fill: none;
    stroke: #fa0;
    stroke-linecap: round;
    stroke-linejoin: round;
}
</style>


